<template>
  <component :is="Impl">
    <slot></slot>
  </component>
</template>

<script setup>
import { useThemedComponent } from "@/composables/useThemedComponent.js";

const Impl = useThemedComponent("webButton");
</script>
